export default "__VITE_ASSET__3f38fdee__"